import $ from 'jquery';

export default function () {
  // if not on the document page
  if ( !$('#doc-viewer').length ) {
    return;
  }

  let $docFirstChild = $('#doc-viewer > div > div:first-child');
  if ($docFirstChild && $docFirstChild.length && ! $docFirstChild[0].innerText.trim()) {
    $docFirstChild.remove();
  }

  const docProduct = $('#doc-viewer').data('product').toLowerCase().trim();
  const docTitle = $('.js-doc-title').text().toLowerCase().trim();

  const $docFirstParagraph = $('#doc-viewer > div:first-child > p:first-of-type');
  const docFirstParagraphText = $docFirstParagraph && $docFirstParagraph.length
    ? $docFirstParagraph.text().toLowerCase().trim()
    : null;
  const $docSecondParagraph = $('#doc-viewer > div:first-child > p:first-of-type + p, #doc-viewer > div:first-child > p:first-of-type + h1');
  const docSecondParagraphText = $docSecondParagraph && $docSecondParagraph.length
    ? $docSecondParagraph.text().toLowerCase().trim()
    : null;

  // Add class to the first paragraph
  if (docFirstParagraphText && docFirstParagraphText.includes(docProduct)) {
    $docFirstParagraph.addClass('has-product-name');
  }

  // Add class to the second paragraph/h1
  if (docSecondParagraphText && docTitle.includes(docSecondParagraphText)) {
    $docSecondParagraph.addClass('doc-title');
  }

  // Scroll to anchor on the doc viewer page
  $('#doc-viewer a[href*="#"]').on('click', function(event) {
    event.preventDefault();

    const id = $(this).attr('href').replace('#', '');
    const target = $(`[name=${id}]`).offset().top - $('.js-header').height();

    $('html, body').animate({scrollTop: target}, 500);
  });

  // move table header above table
  $('#doc-viewer table + p span[style*="-aw-bookmark-end"]').each(function () {
    $(this).closest('p').insertBefore($(this).closest('p').prev('table'));
  });

  $('#doc-viewer span, #doc-viewer p').each(function() {
    let fsize = this.style.fontSize;
    let size = parseInt(fsize.replace('pt',''));
    if (size && size < 10) {
      $(this).addClass('docViewerSmallText');
    }

    let family = this.style.fontFamily;
    if (family === 'Wingdings') {
      $(this).addClass('windings-family');
    }
  });

  $('#doc-viewer p span').each(function () {
    if ( $(this).text().toLowerCase().includes('figure') ) {
      // move figure header above figure
      const img = $(this).prevAll('img:first');

      if ( img.length ) {
        img.next('br').remove();
        img.appendTo(img.closest('p')).css('margin-top', '8px');
      }
      // add class to the figure header
      $(this).closest('p').addClass('figure-header');
    } else if ( $(this).text().toLowerCase().includes('table') ) {
      // add class to the table header
      $(this).closest('p').addClass('table-header');
    } else if ($(this).text().trim() === 'Gilead Sciences, Inc. is providing this document to you, a US Healthcare Professional, in response to your unsolicited request for medical information.') {
      console.log('removing extra disclaimer');
      $(this).parent().parent().remove();
    }
  });

  // remove div wrapper from tables
  $('#doc-viewer table').each(function () {
    if ( $(this).closest('div[style*="text-align:center"]').length ) {
      $(this).unwrap();
    }
  });

  // open all third-party links in a new tab
  $('#doc-viewer a').not('[href^="#"]').each(function () {
    $(this).attr('target', '_blank');
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/project/doc-viewer.js